import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const Replace = createSvgIcon(
  <svg width="12px" height="18px" viewBox="0 0 12 18" version="1.1">
    <defs>
      <path
        d="M15.8333333,16.6666667 L15.8333333,18.3333333 L4.16666667,18.3333333 L4.16666667,16.6666667 L15.8333333,16.6666667 Z M12.8125,6.66666667 L12.8125,11.9772727 L15,11.9772727 L12.0833333,15 L9.16666667,11.9772727 L11.3541667,11.9772727 L11.3541667,6.66666667 L12.8125,6.66666667 Z M7.91666667,1.66666667 L10.8333333,4.68939394 L8.64583333,4.68939394 L8.64583333,10 L7.1875,10 L7.1875,4.68939394 L5,4.68939394 L7.91666667,1.66666667 Z"
        id="replace-path-1"
      ></path>
    </defs>
    <g id="replace-TargetField-Popper" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="replace-Map-Data4A" transform="translate(-1320.000000, -841.000000)">
        <g id="ic_replace" transform="translate(1316.000000, 840.000000)">
          <mask id="replace-mask-2" fill="white">
            <use href="#replace-path-1"></use>
          </mask>
          <use id="Mask" fill="#000000" fillRule="evenodd" href="#replace-path-1"></use>
          <g id="Colors/Dark-Gray" mask="url(#replace-mask-2)" fill="#616161" fillRule="evenodd">
            <g transform="translate(-16.666667, -16.666667)" id="replace-Rectangle-Copy-29">
              <rect x="0" y="0" width="41.6666667" height="41.6666667"></rect>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>,
  'Replace'
);
